import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b56401a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "event-sales-items"
}
const _hoisted_2 = { class: "event-sales-items__row" }
const _hoisted_3 = {
  key: 0,
  class: "event-sales-items__total-selected"
}

import { computed, PropType } from 'vue'
import { PublicService } from '@/models/public/bookingWidget.model'
import {
  EventInformation,
  ExperienceTimeslot,
  SalesItemInformationWithQuantity,
} from '@/models/public/service.model'
import { TRANSLATION_TYPE } from '@/enums/public'
import { ALERT_TYPES } from '@/enums/components'
import { formatCurrency } from '@/utils/formatters'
import BaseIcon from '@/components/BaseIcon.vue'
import BaseNumberIncrementer from '@/components/BaseNumberIncrementer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventSalesItems',
  props: {
  selectedService: {
    type: Object as PropType<PublicService>,
    required: true,
  },
  selectedSlots: {
    type: Array as PropType<ExperienceTimeslot[]>,
    default: () => [],
  },
  salesItemQuantities: {
    type: Object as PropType<Record<string, number>>,
    required: true,
  },
  eventInfo: {
    type: Object as PropType<EventInformation | undefined>,
    default: undefined,
  },
  errors: {
    type: Object as PropType<Record<string, unknown> | undefined>,
    default: undefined,
  },
},
  emits: ["update:salesItemQuantities"],
  setup(__props, { emit }: { emit: ({
  (
    e: 'update:salesItemQuantities',
    newSalesItemQuantities: Record<string, number>,
  ): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const salesItemsWithQuantities = computed<SalesItemInformationWithQuantity[]>(
  () => {
    const salesItems = props.eventInfo?.sales_items || []
    return salesItems.map((item) => ({
      ...item,
      quantity: props.salesItemQuantities[item.identifier] || 0,
    }))
  },
)

const groupSize = computed<number>(() =>
  Object.values(props.salesItemQuantities).reduce(
    (a, b) => Number(a) + Number(b),
    0,
  ),
)

const maxGroupSize = computed<number>(() => {
  return props.eventInfo?.available_capacity ?? 0
})

const leftoverAvailability = computed<number>(() => {
  return maxGroupSize.value - groupSize.value
})

const getSalesItemLabel = (salesItem: SalesItemInformationWithQuantity) => {
  if (salesItem.name?.content) {
    return `${salesItem.name?.content} ${formatCurrency(salesItem.price)}`
  }
  return `${salesItem.name} ${formatCurrency(salesItem.price)}`
}

const handleSalesItemIncremet = (
  salesItem: SalesItemInformationWithQuantity,
  increment: number,
) => {
  const newSalesItemQuantities = {
    ...props.salesItemQuantities,
    [salesItem.identifier]: Math.max(0, salesItem.quantity + increment),
  }
  emit('update:salesItemQuantities', newSalesItemQuantities)
}

return (_ctx: any,_cache: any) => {
  const _component_AlertBanner = _resolveComponent("AlertBanner")!

  return (__props.eventInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(salesItemsWithQuantities), (salesItem) => {
          return (_openBlock(), _createElementBlock("div", {
            key: salesItem.id,
            class: "event-sales-items__row-wrapper"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(BaseNumberIncrementer, {
                label: getSalesItemLabel(salesItem),
                amount: salesItem.quantity,
                "min-amount": 0,
                "max-amount": salesItem.quantity + _unref(leftoverAvailability),
                onClickMinus: () => handleSalesItemIncremet(salesItem, -1),
                onClickPlus: () => handleSalesItemIncremet(salesItem, 1)
              }, null, 8, ["label", "amount", "max-amount", "onClickMinus", "onClickPlus"]),
              (salesItem.name?.type === _unref(TRANSLATION_TYPE).MACHINE)
                ? (_openBlock(), _createBlock(BaseIcon, {
                    key: 0,
                    icon: "google-translate",
                    class: "event-sales-items__gt-icon"
                  }))
                : _createCommentVNode("", true)
            ]),
            (__props.errors?.sales_items?.[salesItem.identifier])
              ? (_openBlock(), _createBlock(_component_AlertBanner, {
                  key: 0,
                  "alert-type": _unref(ALERT_TYPES).WARNING,
                  text: __props.errors?.sales_items?.[salesItem.identifier][0],
                  class: "event-sales-items__alert"
                }, null, 8, ["alert-type", "text"]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (__props.eventInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('participants.maxGroupSizeText', { maxGroupSize: _unref(maxGroupSize), groupSize: _unref(groupSize) })), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})